import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './scripts/util'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import Mock from './mock'
// Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'
import {http} from './scripts/Http';
import './scripts/cache';
import { authCheckIntercept } from './scripts/auth'
import util from '@/common/js/util'
Vue.use(http)
Vue.config.productionTip = false
Vue.use(ElementUI);
router.addBeforeInterceptor(authCheckIntercept);
Vue.prototype.$comUtils = util    // 将共通方法改写为Vue的原型属性
Vue.prototype.loading = function (msg){
  const loading = this.$loading({
    lock: true,
    text: msg||'加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
 return loading;
}
// router.beforeEach((to, from, next) => {
//   //NProgress.start();
//   if (to.path == '/login') {
//     sessionStorage.removeItem('user');
//   }
//   let user = JSON.parse(sessionStorage.getItem('user'));
//   if (!user && to.path != '/login') {
//     next({ path: '/login' })
//   } else {
//     next()
//   }
// })

//router.afterEach(transition => {
//NProgress.done();
//});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
